//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Represents the attendance association of a StreakType. */
export const StreakStructureType = {
    /** The StreakType is associated with any attendance record. */
    AnyAttendance: 0,

    /** The StreakType is associated with attendance to a single group. */
    Group: 1,

    /** The StreakType is associated with attendance to groups of a given type. */
    GroupType: 2,

    /** The StreakType is associated with attendance to groups within group types of a common purpose (defined type). */
    GroupTypePurpose: 3,

    /** The StreakType is associated with attendance specified by a check-in configuration. */
    CheckInConfig: 4,

    /** The StreakType is associated with interactions in a certain channel. */
    InteractionChannel: 5,

    /** The StreakType is associated with interactions in a certain component. */
    InteractionComponent: 6,

    /** The StreakType is associated with interactions over a certain. */
    InteractionMedium: 7,

    /** The StreakType is associated with financial transactions. */
    FinancialTransaction: 8
} as const;

/** Represents the attendance association of a StreakType. */
export const StreakStructureTypeDescription: Record<number, string> = {
    0: "Attendance: Any",

    1: "Attendance: Group",

    2: "Attendance: Group Type",

    3: "Attendance: Group Type Purpose",

    4: "Attendance: Check-In Configuration",

    5: "Interaction: Channel",

    6: "Interaction: Component",

    7: "Interaction: Medium",

    8: "Financial Transaction"
};

/** Represents the attendance association of a StreakType. */
export type StreakStructureType = typeof StreakStructureType[keyof typeof StreakStructureType];
